import { NextRouter } from 'next/router'

const REDIRECT_PARAMS = ['dateFrom', 'dateTo', 'dateType', 'status', 'activeClientId']

export function appendRedirectParamsFromRouter(router: NextRouter): string {
  let redirectUrl = router.query.redirect as string

  REDIRECT_PARAMS.forEach(i => {
    if (router.query[i]) {
      redirectUrl += `&${i}=${router.query[i]}`
    }
  })

  return redirectUrl
}
